import { Directive, inject } from '@angular/core';
import { QuestionItemsJsonEditorService } from './question-items-json-editor.service';
import { JsonEditorDialogService } from './json-editor-dialog.service';

@Directive({
  selector: '[dojoJsonEditorTrigger]',
  standalone: true,
  providers: [QuestionItemsJsonEditorService, JsonEditorDialogService],
  host: {
    '(click)': 'questionItemsJsonEditorService.openEditor()',
    class: 'cursor-pointer',
  },
})
export class JsonEditorTriggerDirective {
  readonly questionItemsJsonEditorService = inject(QuestionItemsJsonEditorService);
}
